import { render } from "./HorizontalLayoutRenderer.vue?vue&type=template&id=76c299fb&ts=true"
import script from "./HorizontalLayoutRenderer.vue?vue&type=script&lang=ts"
export * from "./HorizontalLayoutRenderer.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__